export default __webpack_public_path__ + "static/media/Infernal Mantle of the Living Legend.102c8fc2.jpg";